import DirectionsCarOutlined from "@material-ui/icons/esm/DirectionsCarOutlined";
import React from 'react';
import StackedIcon from 'components/Icons/StackedIcon';
import { DARK_GRAY } from 'constants/colors';
import useStyles from './VehicleIconStyles';
export default function NoVehicle() {
  const {
    icon
  } = useStyles();
  return /*#__PURE__*/React.createElement(StackedIcon, null, /*#__PURE__*/React.createElement("svg", {
    className: icon
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: "100%",
    x2: "100%",
    y2: 0,
    strokeWidth: 4,
    strokeLinecap: "round",
    stroke: DARK_GRAY
  })), /*#__PURE__*/React.createElement(DirectionsCarOutlined, {
    className: icon
  }));
}